export function isIntegerOrFloatGreaterThan0(input: unknown) {
    return Number.isFinite(input) && Number(input) > 0 && !Number.isNaN(input);
}

export function isIntegerGreaterThan0(input: unknown) {
    return Number.isInteger(input) && Number(input) > 0 && !Number.isNaN(input);
}

export function isIntegerGreaterThanOrEqualTo0(input: unknown) {
    return Number.isInteger(input) && Number(input) >= 0 && !Number.isNaN(input);
}

export function isIntegerBetween(input: unknown, min: number, max: number) {
    return Number.isInteger(input) && Number(input) >= min && Number(input) <= max;
}

export function isPositiveInt(input) {
    const str = "" + input;

    if (str.trim() === "0") {
        return false;
    }

    return !!str.match(/^[0-9]+$/);
}

export function isNaturalNumber(input) {
    const str = "" + input;

    return str.match(/^[0-9]+$/);
}

export function isPositiveIntOrEmpty(input) {
    const str = "" + input;

    if (str.trim() === "0") {
        return false;
    }

    if (!input) {
        return true;
    }

    if (str === "") {
        return true;
    }

    return isPositiveInt(str);
}
